// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3ofj4","question":"Question_question__JuXFh","description":"Question_description__2b2nY"};